import Vue from "vue";
import Vuex from "vuex";
import  AuthModule from  "./auth";
import LoadingModule from "./loading";
import SnackbarModule from "./snackbar";
import ForumsModule from "./forums";
import AssessmentModule from "./assessments";
import createPersistedState from "vuex-persistedstate";
import ChatsModule from "./chats"
import BlogsModule from "./blogs"

Vue.use(Vuex);
export default  new Vuex.Store({
    strict: false,
    modules: {
        auth: AuthModule,
        loading: LoadingModule,
        snackbar: SnackbarModule,
        forums: ForumsModule,
        chats: ChatsModule,
        assessments: AssessmentModule,
        blogs: BlogsModule
    },
    plugins: [createPersistedState()]
})

export * as Auth from './auth';
export * as Loading from './loading';
export * as SnackBar from './snackbar';
export * as Forums from './forums';
export * as Blogs from "./blogs"